import { useContext } from 'react';
import Terms from '../../../ui-components/Terms';
import { giftcardState } from '../client-state/giftcard-state-context';
import useLocale from '../../../Hooks/use-locale';
import useLocalize from '../../../Hooks/useLocalize';
import { termsReducerActionTypes } from '../../../redusers/terms-reducer';
import useGiftcardShop from '../server-data/use-giftcard-shop';
import useGiftcardMinimalShop from '../server-data/use-giftcard-minimal-shop';

interface TermsWithDataProps {
  textColor?: string;
}

const TermsWithData = (props: TermsWithDataProps) => {
  const { data: minimalShop } = useGiftcardMinimalShop();
  const { data: shop } = useGiftcardShop();
  const { state, dispatch } = useContext(giftcardState);
  const { languageAsEnum } = useLocale();
  const localize = useLocalize();

  return (
    <Terms
      checked={state.terms.termsChecked}
      link={
        shop?.bookingLocalizations?.termsLink?.[languageAsEnum] ||
        shop?.configuration?.termsUrl
      }
      text={
        shop?.bookingLocalizations?.termsText?.[languageAsEnum] ||
        localize('product.acceptTerms')
      }
      onChange={(checked) => {
        dispatch({
          type: termsReducerActionTypes.UPDATE_TERMS_CHECKED,
          payload: checked,
        });
      }}
      error={Boolean(state.errors.terms)}
      noMargin={minimalShop?.mailchimp}
      textColor={props.textColor}
    />
  );
};

export default TermsWithData;
